// Date/time helpers and color utilities for WeekCalendar sub-components.

export const DEFAULT_HOUR_PX = 72;   // pixels per hour (default zoom)
export const MIN_HOUR_PX = 40;       // pixels per hour (max zoom-out)
export const MAX_HOUR_PX = 160;      // pixels per hour (max zoom-in)
// Legacy alias — some callers still import HOUR_PX. Prefer the prop-passed
// `hourPx` value in sub-components so zoom works dynamically.
export const HOUR_PX = DEFAULT_HOUR_PX;
export const SNAP_MIN = 15;       // snap interval in minutes
export const DAYS_LABELS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

export function fmtTime(d) {
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function startOfWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();           // 0=Sun..6=Sat
  const diff = day === 0 ? -6 : 1 - day; // Monday as start
  d.setDate(d.getDate() + diff);
  return d;
}

export function addDays(d, n) {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

export function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
}

export function buildHourRows() {
  const out = [];
  for (let h = 0; h < 24; h++) {
    const label = h === 0 ? "12 AM" : h < 12 ? `${h} AM` : h === 12 ? "12 PM" : `${h - 12} PM`;
    out.push({ h, label });
  }
  return out;
}
export const HOURS = buildHourRows();

export function toTimeStr(d) {
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
export function setTime(date, hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const r = new Date(date);
  r.setHours(h || 0, m || 0, 0, 0);
  return r;
}

// ---------- colour helpers ----------
export const LEAVE_COLORS = {
  annual: "#0ea5e9",
  personal: "#8b5cf6",
  sick: "#ef4444",
};

export function entryColor(entry, client, activity, category) {
  if (entry.leave_type && LEAVE_COLORS[entry.leave_type]) return LEAVE_COLORS[entry.leave_type];
  return category?.color || client?.color || activity?.color || "#145c8c";
}

export function hexA(hex, alpha) {
  const c = hex.replace("#", "");
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function tint(hex, ratio) {
  const c = hex.replace("#", "");
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  const m = (v) => Math.round(v + (255 - v) * ratio);
  return `rgb(${m(r)}, ${m(g)}, ${m(b)})`;
}

export function shade(hex, ratio) {
  const c = hex.replace("#", "");
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  const m = (v) => Math.round(v * (1 - ratio));
  return `rgb(${m(r)}, ${m(g)}, ${m(b)})`;
}
